import type {z} from "zod";

import {createValidationIssue, requiredFieldValidation} from "@project/i18n";
import {AddTaskBody} from "@project/sdk/admin/zod";
import {z as zod} from "zod";

import {taskFieldLabelIds} from "../../messages/tasks.messages";

const baseAddTaskTitleSchema = AddTaskBody.shape.title;

export const addTaskTitleSchema = zod.string().superRefine((value, ctx) => {
  if (!value.trim()) {
    ctx.addIssue(createValidationIssue(requiredFieldValidation(taskFieldLabelIds.title)));

    return;
  }

  const result = baseAddTaskTitleSchema.safeParse(value);

  if (!result.success) {
    for (const issue of result.error.issues) {
      ctx.addIssue({...issue});
    }
  }
});

export const addTaskRichSchema = AddTaskBody.extend({
  title: addTaskTitleSchema,
});
export type AddTaskFormPayload = z.infer<typeof addTaskRichSchema>;

export const draftTaskRichSchema = addTaskRichSchema.partial();
export type DraftTaskFormPayload = z.infer<typeof draftTaskRichSchema>;
